import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from 'src/helpers/apiCall'
import { GET } from 'src/consts/methods'
import {
  FETCH_BATCH_INVOICE_CUSTOMER,
  FETCH_BATCH_INVOICE_CUSTOMER_FAIL,
  FETCH_BATCH_INVOICE_CUSTOMER_SUCCESS,
  FetchBatchInvoiceActionType
} from 'src/redux/batchInvoiceCustomerReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchBatchInvoiceCustomerFlow({ payload }: FetchBatchInvoiceActionType): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, {
      endpoint: `/admin/batch_invoice_customers/${payload.id}`,
      method: GET,
      params: {}
    })
    yield put(FETCH_BATCH_INVOICE_CUSTOMER_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_BATCH_INVOICE_CUSTOMER_FAIL())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchBatchInvoiceCustomerSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_BATCH_INVOICE_CUSTOMER, FetchBatchInvoiceCustomerFlow)
}
